import { ORDER_STATUSES } from '../define/constants';

export const isOrderConfirmed = (status) => {
  switch (status) {
    case ORDER_STATUSES.confirmedBooking:
    case ORDER_STATUSES.confirmedPostponed:
    case ORDER_STATUSES.confirmedSuspended:
    case ORDER_STATUSES.confirmedVoucher:
      return true;
    default:
      return false;
  }
};
